var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcResizePanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 1V2H3.04033L7.33333 6.291L6.62633 7L2.33333 2.707V6H1.33333V1H6.33333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 9.708L10.0373 9L14.3333 13.293V10H15.3333V15H10.3333V14H13.6263L9.33333 9.708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResizePanel);
export default __webpack_public_path__ + "static/media/ic-resize-panel.799533518d4f22b865d6e27779fe5b3d.svg";
export { ForwardRef as ReactComponent };